import gql from 'graphql-tag'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  deleteContractEventAsset: { contractEventAsset: { id: string } }
}

const mutateHandler = handleFetchResult<IPayload, string>({
  handler: (data) => data.deleteContractEventAsset.contractEventAsset.id,
  name: 'Asset',
})

export default function deleteContractAsset(assetId: string) {
  return client.gql
    .mutate({
      mutation: deleteAssetMutation,
      variables: { input: { id: assetId } },
    })
    .then(mutateHandler)
}

const deleteAssetMutation = gql`
  mutation deleteContractEventAsset($input: DeleteContractEventAssetInput!) {
    deleteContractEventAsset(input: $input) {
      contractEventAsset {
        id
      }
    }
  }
`
